/**
 * Dynamically loads a CSS file by creating a link element and appending it to the document head.
 * The function returns a Promise that resolves when the CSS is loaded or rejects if loading fails.
 */
export const loadStylesheet = (url: string) =>
  new Promise<void>((resolve, reject) => {
    if (document.querySelector(`link[href="${url}"]`)) {
      resolve();
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;

    link.onload = () => resolve();
    link.onerror = () => reject(new Error(`Failed to load CSS: ${url}`));

    document.head.appendChild(link);
  });

export default loadStylesheet;
